
{
  "familyId": "GET-BREUK-KEER",
  "questions": [
    {
      "id": "GET-BREUK-KEER-001",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Hoeveel is $\\frac{1}{2} \\times \\frac{1}{3}$?",
      "options": ["$\\frac{1}{6}$", "$\\frac{2}{5}$", "$\\frac{1}{5}$", "$\\frac{2}{6}$"],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-keer-optellen-tnoemer", "label": "Teller en noemer beide opgeteld i.p.v. vermenigvuldigd", "optionIndex": 1 },
          { "id": "get.breuk-keer-noemer-optellen", "label": "Noemer opgeteld i.p.v. vermenigvuldigd", "optionIndex": 2 },
          { "id": "get.breuk-keer-teller-optellen", "label": "Teller opgeteld i.p.v. vermenigvuldigd", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [
              { "numerator": 1, "denominator": 2, "label": "$\\frac{1}{2}$" },
              { "numerator": 1, "denominator": 3, "label": "$\\frac{1}{3}$" }
            ],
            "label": "Vergelijk: $\\frac{1}{2}$ en $\\frac{1}{3}$ — wat is hun product?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 6,
            "visualType": "bar",
            "label": "$\\frac{1}{2} \\times \\frac{1}{3} = \\frac{1}{6}$"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken vermenigvuldigen",
            "content": "Bij breuken vermenigvuldigen: teller × teller en noemer × noemer. Dus ½ × ⅓ = (1×1)/(2×3) = ⅙.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij breuken vermenigvuldigen: teller × teller en noemer × noemer. Teller: 1 × 1 = 1. Noemer: 2 × 3 = 6. Antwoord: $\\frac{1}{6}$. Controleer: $\\frac{1}{6}$ is kleiner dan $\\frac{1}{2}$ en kleiner dan $\\frac{1}{3}$ — dat klopt, want je neemt een deel van een deel.",
        "solutionSteps": [
          "Teller × teller: 1 × 1 = 1",
          "Noemer × noemer: 2 × 3 = 6",
          "Antwoord: $\\frac{1}{6}$",
          "Controleer: $\\frac{1}{6}$ < $\\frac{1}{2}$ en $\\frac{1}{6}$ < $\\frac{1}{3}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1 × 1 = 1 (teller) en 2 × 3 = 6 (noemer), dus $\\frac{1}{6}$.",
          "1": "Je hebt de tellers en noemers opgeteld: 1+1=2 en 2+3=5 → $\\frac{2}{5}$. Maar bij vermenigvuldigen moet je maal doen, niet optellen. Onthoud: teller × teller en noemer × noemer.",
          "2": "De teller klopt (1×1=1), maar de noemer is opgeteld (2+3=5) in plaats van vermenigvuldigd (2×3=6). Onthoud: ook de noemers vermenigvuldig je.",
          "3": "De noemer klopt (2×3=6), maar de teller is opgeteld (1+1=2) in plaats van vermenigvuldigd (1×1=1). Onthoud: ook de tellers vermenigvuldig je."
        }
      }
    },
    {
      "id": "GET-BREUK-KEER-002",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\frac{2}{3} \\times \\frac{3}{4}$",
      "options": ["$\\frac{1}{2}$", "$\\frac{6}{12}$", "$\\frac{5}{7}$", "$\\frac{2}{4}$"],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_simplify",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [
              { "numerator": 2, "denominator": 3, "label": "$\\frac{2}{3}$" },
              { "numerator": 3, "denominator": 4, "label": "$\\frac{3}{4}$" }
            ],
            "label": "Bereken: $\\frac{2}{3} \\times \\frac{3}{4}$"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "visualType": "bar",
            "label": "$\\frac{2}{3} \\times \\frac{3}{4} = \\frac{6}{12} = \\frac{1}{2}$"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen en vereenvoudigen",
            "content": "Teller × teller = 2×3 = 6. Noemer × noemer = 3×4 = 12. Uitkomst: 6/12. Vereenvoudig: 6/12 ÷ 6/6 = ½.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Teller × teller = 2 × 3 = 6. Noemer × noemer = 3 × 4 = 12. Uitkomst: $\\frac{6}{12}$. Vereenvoudig: de GGD van 6 en 12 is 6. Dus $\\frac{6}{12}$ ÷ $\\frac{6}{6}$ = $\\frac{1}{2}$.",
        "solutionSteps": [
          "Teller × teller: 2 × 3 = 6",
          "Noemer × noemer: 3 × 4 = 12",
          "Uitkomst: $\\frac{6}{12}$",
          "Vereenvoudig (GGD = 6): $\\frac{6}{12}$ = $\\frac{1}{2}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 2×3=6 en 3×4=12 geeft $\\frac{6}{12}$, vereenvoudigd = $\\frac{1}{2}$.",
          "1": "$\\frac{6}{12}$ is de tussenstap vóór vereenvoudigen. Je bent er bijna — deel teller én noemer nog door 6: $\\frac{6}{12}$ = $\\frac{1}{2}$. Onthoud: vereenvoudig altijd je antwoord.",
          "2": "Je hebt de tellers en noemers opgeteld: 2+3=5 en 3+4=7 → $\\frac{5}{7}$. Maar bij vermenigvuldigen tel je niet op — je vermenigvuldigt teller × teller en noemer × noemer.",
          "3": "Je hebt alleen de eerste breuk gebruikt en de noemer overgenomen. Vermenigvuldig beide breuken volledig: $\\frac{2}{3} \\times \\frac{3}{4}$ = $\\frac{6}{12}$ = $\\frac{1}{2}$."
        }
      }
    },
    {
      "id": "GET-BREUK-KEER-003",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Emma heeft $\\frac{1}{4}$ van een taart. Ze geeft $\\frac{1}{2}$ daarvan aan haar zus. Hoeveel taart heeft haar zus?",
      "options": ["$\\frac{1}{8}$", "$\\frac{3}{4}$", "$\\frac{1}{2}$", "$\\frac{2}{8}$"],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_context",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "visualType": "circle-clean",
            "label": "Emma's deel: $\\frac{1}{4}$ van de taart"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 8,
            "visualType": "circle-clean",
            "label": "Voor zus: $\\frac{1}{2} \\times \\frac{1}{4} = \\frac{1}{8}$"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "'De helft van' = vermenigvuldigen",
            "content": "'De helft van ¼' betekent ½ × ¼. Teller: 1×1=1. Noemer: 2×4=8. Antwoord: ⅛ van de taart.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "\"De helft van een kwart\" betekent $\\frac{1}{2} \\times \\frac{1}{4}$. Teller: 1 × 1 = 1. Noemer: 2 × 4 = 8. Antwoord: $\\frac{1}{8}$ van de taart. Dat is logisch: een half van een kwart is een nog kleiner stukje.",
        "solutionSteps": [
          "\"De helft daarvan\" = $\\frac{1}{2} \\times \\frac{1}{4}$",
          "Teller × teller: 1 × 1 = 1",
          "Noemer × noemer: 2 × 4 = 8",
          "Antwoord: $\\frac{1}{8}$ van de taart"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2} \\times \\frac{1}{4}$: teller 1×1=1 en noemer 2×4=8 → $\\frac{1}{8}$.",
          "1": "Je hebt opgeteld in plaats van vermenigvuldigd: $\\frac{1}{4} + \\frac{1}{2}$ = $\\frac{3}{4}$. Maar \"de helft DAARVAN\" is vermenigvuldigen, niet optellen. Onthoud: 'van' = ×.",
          "2": "Je hebt alleen $\\frac{1}{2}$ als antwoord gegeven en de $\\frac{1}{4}$ genegeerd. \"De helft van een kwart\" is kleiner dan $\\frac{1}{2}$. Onthoud: een deel van een deel is altijd kleiner.",
          "3": "De noemer is correct (2×4=8), maar de teller is opgeteld (1+1=2) in plaats van vermenigvuldigd (1×1=1). Onthoud: ook de tellers vermenigvuldig je."
        }
      }
    },
    {
      "id": "GET-BREUK-KEER-004",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\frac{3}{5} \\times \\frac{2}{7}$",
      "options": ["$\\frac{6}{35}$", "$\\frac{5}{12}$", "$\\frac{6}{12}$", "$\\frac{5}{35}$"],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_no_simplify",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken vermenigvuldigen",
            "content": "Teller × teller = 3×2 = 6. Noemer × noemer = 5×7 = 35. Antwoord: 6/35. Dit is al vereenvoudigd (6 en 35 hebben geen gemeenschappelijke deler).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Teller × teller = 3 × 2 = 6. Noemer × noemer = 5 × 7 = 35. Antwoord: $\\frac{6}{35}$. Vereenvoudigen? 6 en 35 hebben geen gemeenschappelijke deler, dus $\\frac{6}{35}$ is al in de eenvoudigste vorm.",
        "solutionSteps": [
          "Teller × teller: 3 × 2 = 6",
          "Noemer × noemer: 5 × 7 = 35",
          "Antwoord: $\\frac{6}{35}$",
          "Controleer vereenvoudigen: 6 en 35 hebben geen gemeenschappelijke deler → klaar"
        ],
        "distractorExplanations": {
          "0": "Goed! 3×2=6 en 5×7=35, dus $\\frac{6}{35}$.",
          "1": "Je hebt de tellers en noemers opgeteld: 3+2=5 en 5+7=12 → $\\frac{5}{12}$. Maar bij vermenigvuldigen moet je maal doen: 3×2=6 en 5×7=35. Onthoud: vermenigvuldigen ≠ optellen.",
          "2": "De teller klopt (3×2=6), maar de noemer is opgeteld (5+7=12) in plaats van vermenigvuldigd (5×7=35). Onthoud: ook de noemers vermenigvuldig je.",
          "3": "De noemer klopt (5×7=35), maar de teller is opgeteld (3+2=5) in plaats van vermenigvuldigd (3×2=6). Onthoud: ook de tellers vermenigvuldig je."
        }
      }
    },
    {
      "id": "GET-BREUK-KEER-005",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Een tuinman besproeit $\\frac{2}{3}$ van zijn tuin. Daarvan is $\\frac{3}{4}$ gras. Welk deel van de hele tuin is besproeid gras?",
      "options": ["$\\frac{1}{2}$", "$\\frac{5}{7}$", "$\\frac{6}{7}$", "$\\frac{2}{4}$"],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_context_garden",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "'Deel van een deel' = vermenigvuldigen",
            "content": "¾ van ⅔ = ¾ × ⅔ = (3×2)/(4×3) = 6/12 = ½. De helft van de tuin is besproeid gras.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "\"$\\frac{3}{4}$ van $\\frac{2}{3}$\" = $\\frac{3}{4} \\times \\frac{2}{3}$. Teller: 3 × 2 = 6. Noemer: 4 × 3 = 12. Uitkomst: $\\frac{6}{12}$ = $\\frac{1}{2}$. De helft van de hele tuin is besproeid gras.",
        "solutionSteps": [
          "\"¾ van ⅔\" = $\\frac{3}{4} \\times \\frac{2}{3}$",
          "Teller × teller: 3 × 2 = 6",
          "Noemer × noemer: 4 × 3 = 12",
          "Uitkomst: $\\frac{6}{12}$",
          "Vereenvoudig: $\\frac{6}{12}$ = $\\frac{1}{2}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4} \\times \\frac{2}{3}$ = $\\frac{6}{12}$ = $\\frac{1}{2}$.",
          "1": "Je hebt de tellers en noemers opgeteld: 3+2=5 en 4+3=7 → $\\frac{5}{7}$. Maar 'van' betekent vermenigvuldigen, niet optellen. Onthoud: 'van' = ×.",
          "2": "Je hebt de breuken opgeteld: $\\frac{2}{3} + \\frac{3}{4}$ ≈ $\\frac{6}{7}$. Maar de vraag is 'deel van een deel', dat is vermenigvuldigen. Onthoud: 'van' = ×.",
          "3": "Je hebt alleen de eerste breuk vereenvoudigd. $\\frac{2}{4}$ = $\\frac{1}{2}$ is toevallig hetzelfde antwoord, maar de berekening klopt niet. De juiste weg: $\\frac{3}{4} \\times \\frac{2}{3}$ = $\\frac{6}{12}$ = $\\frac{1}{2}$."
        }
      }
    },
    {
      "id": "GET-BREUK-KEER-CJ-001",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "comparison_judge",
      "question": "Twee leerlingen berekenen $\\frac{2}{3} \\times \\frac{4}{5}$. Wie pakt het correct aan?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "lina", "content": "Lina: \"Teller × teller, noemer × noemer: $\\frac{2 \\times 4}{3 \\times 5} = \\frac{8}{15}$. Dat is al vereenvoudigd.\"" },
            { "id": "noah", "content": "Noah: \"Eerst gelijknamig maken, dan tellers vermenigvuldigen: $\\frac{10}{15} \\times \\frac{12}{15} = \\frac{120}{15}$.\"" }
          ],
          "criterion": "Wie volgt de juiste regel voor vermenigvuldigen van breuken?",
          "correctIndex": 0
        }
      },
      "conceptId": "multiply_fractions_strategy_judge",
      "variantIndex": 6,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.breuk-keer-gelijknamig-eerst", "label": "Gelijknamig-maken-stap onterecht toegepast bij vermenigvuldigen", "optionIndex": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen ≠ optellen",
            "content": "Gelijknamig maken hoort bij plus en min, niet bij keer. Bij keer doe je gewoon: teller × teller, noemer × noemer. $\\frac{2}{3} \\times \\frac{4}{5} = \\frac{8}{15}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Lina volgt de regel: teller × teller, noemer × noemer → $\\frac{8}{15}$. Noah verwart vermenigvuldigen met optellen — gelijknamig maken hoort bij plus/min, niet bij keer.",
        "solutionSteps": [
          "Bij keer: teller × teller, noemer × noemer",
          "Lina: $\\frac{2 \\times 4}{3 \\times 5} = \\frac{8}{15}$ ✓",
          "Noah past gelijknamig maken toe — die stap hoort bij + en − niet bij ×",
          "Lina pakt het correct aan"
        ]
      }
    }
  ]
}
